import FilesGroup from '../../components/File/FilesGroup.js'

export class FilesGroupProps {
  constructor (config = {}) {
    this.required = config.required || false
    this.collapseId = config.collapseId || null
    this.validationMessage = config.validationMessage || null
  }
}

export function getReturnFilesGroups (current) {
  return [
    new FilesGroup({
      key: 'vehicleOdometer',
      title: (current ? 'ТЕКУЩИЕ ' : '') + 'ПОКАЗАНИЯ ОДОМЕТРА',
      readonly: false,
      documentType: 'vehicleOdometer',
      props: new FilesGroupProps({ validationMessage: 'показаний одометра' })
    }),
    new FilesGroup({
      key: 'vehicleFuel',
      title: (current ? 'ТЕКУЩИЙ ' : '') + 'ОСТАТОК ТОПЛИВА',
      readonly: false,
      documentType: 'vehicleFuel',
      props: new FilesGroupProps({ validationMessage: 'остатка топлива' })
    }),
    new FilesGroup({
      key: 'carBodyFront',
      title: 'ОБЩИЙ ВИД СПЕРЕДИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида спереди' })
    }),
    new FilesGroup({
      key: 'carBodyLeft',
      title: 'ОБЩИЙ ВИД СЛЕВА',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида слева' })
    }),
    new FilesGroup({
      key: 'carBodyRight',
      title: 'ОБЩИЙ ВИД СПРАВА',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида справа' })
    }),
    new FilesGroup({
      key: 'carBodyBack',
      title: 'ОБЩИЙ ВИД СЗАДИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида сзади' })
    }),
    new FilesGroup({
      key: 'cabinPassenger',
      title: 'КАБИНА ВНУТРИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'кабины внутри' })
    }),
    new FilesGroup({
      key: 'carBodySide',
      title: 'КУЗОВ ВНУТРИ СО СТОРОНЫ БОКОВОЙ ДВЕРИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'кузова внутри со стороны боковой двери' })
    }),
    new FilesGroup({
      key: 'carBodyInsideFromBack',
      title: 'КУЗОВ ВНУТРИ СО СТОРОНЫ ЗАДНЕЙ ДВЕРИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'кузова внутри со стороны задней двери' })
    })
  ]
}

export function getReturnFilesGroupsMap (current) {
  const filesGroups = getReturnFilesGroups(current)
  return Object.fromEntries(filesGroups.map(filesGroup => [filesGroup.key, filesGroup]))
}

export function getDepartureFilesGroups () {
  return [
    new FilesGroup({
      key: 'vehicleOdometer',
      title: 'ПОКАЗАНИЯ ОДОМЕТРА',
      documentType: 'vehicleOdometer',
      props: new FilesGroupProps({ validationMessage: 'показаний одометра' })
    }),
    new FilesGroup({
      key: 'vehicleFuel',
      title: 'ОСТАТОК ТОПЛИВА',
      documentType: 'vehicleFuel',
      props: new FilesGroupProps({ validationMessage: 'остатка топлива' })
    }),
    new FilesGroup({
      key: 'carBodyFront',
      title: 'ОБЩИЙ ВИД СПЕРЕДИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида спереди' })
    }),
    new FilesGroup({
      key: 'carBodyLeft',
      title: 'ОБЩИЙ ВИД СЛЕВА',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида слева' })
    }),
    new FilesGroup({
      key: 'carBodyRight',
      title: 'ОБЩИЙ ВИД СПРАВА',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида справа' })
    }),
    new FilesGroup({
      key: 'carBodyBack',
      title: 'ОБЩИЙ ВИД СЗАДИ',
      readonly: false,
      documentType: 'vehiclePerspective',
      props: new FilesGroupProps({ validationMessage: 'общего вида сзади' })
    })
  ]
}
